import { Component, computed, input, signal } from '@angular/core';
import { EManagementType } from 'src/models/common.model';
import { IMinioImage } from 'src/models/products.model';

export interface IPortfolioAvatarInput {
  portfolioType: EManagementType | 'PORTFOLIO' | 'STRATEGY',
  img?: string | null,
  image?: IMinioImage | { exists: boolean; url?: string | null; },
}

@Component({
  selector: 'liberro-avatar-photo-tagged',
  standalone: false,
  templateUrl: './liberro-avatar-photo-tagged.component.html',
  styleUrl: './liberro-avatar-photo-tagged.component.less'
})
export class LiberroAvatarPhotoTaggedComponent {
  public isPortfolio = computed<boolean>(() => {
    return this.portfolioDetail()?.portfolioType === 'PORTFOLIO_MANAGEMENT' || this.portfolioDetail()?.portfolioType === 'PORTFOLIO';
  })

  public investmentTypeTooltipVisible = signal<boolean>(false);
  public portfolioDetail = input.required<IPortfolioAvatarInput | null>();

  public onInvestmentTypeTooltipVisibleChange(visible: boolean, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.investmentTypeTooltipVisible.set(visible);
  }
}
